import noop from 'lodash/noop';
import { useEffect, useState } from 'react';

/**
 * Returns whether a key has been pressed
 * @param key
 */
export const useKeyPress = (key: string, callback = noop) => {
  const [keyPressed, setKeyPressed] = useState<boolean>(false);

  function keyDownHandler({ key: pressedKey }: KeyboardEvent) {
    if (pressedKey === key) {
      setKeyPressed(true);
      callback();
    }
  }

  const keyUpHandler = ({ key: pressedKey }: KeyboardEvent) => {
    if (pressedKey === key) {
      setKeyPressed(false);
    }
  };

  useEffect(() => {
    window.addEventListener('keyup', keyUpHandler);
    window.addEventListener('keydown', keyDownHandler);

    /** Clean up on unmount */
    return () => {
      window.removeEventListener('keyup', keyUpHandler);
      window.removeEventListener('keydown', keyDownHandler);
    };
  }, [keyDownHandler, keyUpHandler]);

  return keyPressed;
};
